<template>
  <div>
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center pb-2">
        <SectionTitle>
          テスト成績管理
        </SectionTitle>
      </div>
      <CollapseButton
        :open="isCollapseOpen"
        @click="isCollapseOpen = !isCollapseOpen" />
    </div>
    <b-collapse
      :visible="isCollapseOpen">
      <div
        class="d-flex flex-column"
        style="gap: 8px;">
        <AcademicRecordItem
          v-for="academicRecord in academicSemesters"
          :key="academicRecord.id"
          :can-edit="canEdit"
          :academic-record="academicRecord"
          :user-id="userId" />
      </div>
    </b-collapse>
    <LinkButton
      v-if="canEdit"
      class="my-2"
      :to="`/members/${userId}/profile/academic_records/add`">
      <RoundedIcon
        class="mr-2"
        color="l-blue"
        icon="add" />
      記録する学年を追加
    </LinkButton>
  </div>
</template>

<script>
import LinkButton from '@/components/parts/LinkButton.vue'
import RoundedIcon from '@/components/parts/RoundedIcon.vue'
import SectionTitle from '@/components/view/profile/SectionTitle.vue'
import CollapseButton from '@/components/view/profile/CollapseButton.vue'
import AcademicRecordItem from '@/components/view/profile/academic_records/AcademicRecordItem.vue'
export default {
  components: {
    SectionTitle,
    CollapseButton,
    LinkButton,
    RoundedIcon,
    AcademicRecordItem,
  },
  props: {
    canEdit: {
      type: Boolean,
      required: true,
    },
    userId: {
      type: String,
      required: true,
    },
    academicSemesters: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isCollapseOpen: true,
      
    }
  },
}
</script>

<style>

</style>